import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthguardService } from './services/authguard/authguard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'onboarding',
    pathMatch: 'full'
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./screens/onboarding/onboarding.module').then(m => m.OnboardingPageModule)
  },

  {
    path: 'tabs-page',
    canActivate: [AuthguardService],
    loadChildren: () => import('./screens/tabs-page/tabs-page.module').then(m => m.TabsPagePageModule)
  },
  {
    path: 'installation-steps',
    loadChildren: () => import('./screens/installation/installation-steps/installation-steps.module').then( m => m.InstallationStepsPageModule)
  },
  {
    path: 'submit-installation',
    loadChildren: () => import('./screens/installation/submit-installation/submit-installation.module').then( m => m.SubmitInstallationPageModule)
  },
  {
    path: 'success-installation-modal',
    loadChildren: () => import('./screens/installation/success-installation-modal/success-installation-modal.module').then( m => m.SuccessInstallationModalPageModule)
  },
  {
    path: 'referand-successmodel',
    loadChildren: () => import('./components/referand-successmodel/referand-successmodel.module').then( m => m.ReferandSuccessmodelPageModule)
  },
  {
    path: 'capture-claim-image',
    loadChildren: () => import('./screens/installation/capture-claim-image/capture-claim-image.module').then( m => m.CaptureClaimImagePageModule)
  },

];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
